import React from "react";
import { useLang } from "@/i18n/LanguageContext";
import {
  LineChart,
  Compass,
  Workflow,
  BarChart3,
  Cog,
  Sparkles,
  Code2,
  Landmark,
} from "lucide-react";
import Reveal from "./Reveal";

const ICONS = [LineChart, Compass, Workflow, BarChart3, Cog, Sparkles, Code2, Landmark];

export default function Services() {
  const { t } = useLang();

  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-24 md:py-32"
      style={{ background: "var(--sap-gray-50)" }}
    >
      <div className="sap-container">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-16">
          <Reveal className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-6">
              <span className="sap-divider-gold" />
              <span className="sap-overline">{t.services.overline}</span>
            </div>
            <h2
              className="font-serif leading-[1.1] tracking-tight"
              style={{
                fontSize: "clamp(1.9rem, 3.6vw, 3.2rem)",
                color: "var(--sap-navy)",
                fontWeight: 400,
              }}
            >
              {t.services.title}
            </h2>
          </Reveal>
          <Reveal className="lg:col-span-5" delay={120}>
            <p className="text-base md:text-lg leading-relaxed text-neutral-600">
              {t.services.subtitle}
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {t.services.items.map((s, i) => {
            const Icon = ICONS[i] || Sparkles;
            return (
              <Reveal key={i} delay={i * 60}>
                <article
                  data-testid={`service-card-${i}`}
                  className="sap-card h-full flex flex-col group"
                >
                  <div
                    className="inline-flex items-center justify-center w-12 h-12 mb-6 transition-colors"
                    style={{
                      border: "1px solid #e7e7e7",
                      color: "var(--sap-navy)",
                    }}
                  >
                    <Icon size={20} strokeWidth={1.5} />
                  </div>

                  <div
                    className="text-[10px] uppercase tracking-[0.28em] mb-3 text-neutral-400 group-hover:text-[color:var(--sap-gold)] transition-colors"
                  >
                    {String(i + 1).padStart(2, "0")} / 08
                  </div>

                  <h3
                    className="font-serif text-xl leading-snug tracking-tight"
                    style={{ color: "var(--sap-navy)", fontWeight: 500 }}
                  >
                    {s.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-neutral-600">
                    {s.desc}
                  </p>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
